export default function ChevronLeft({ className }) {
  return (
    <svg viewBox="0 0 6 10" className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.1628 1.0876C5.39061 1.31541 5.39061 1.68475 5.1628 1.91256L2.07528 5.00008L5.1628 8.0876C5.39061 8.31541 5.39061 8.68475 5.1628 8.91256C4.935 9.14037 4.56565 9.14037 4.33785 8.91256L0.837847 5.41256C0.610041 5.18475 0.610041 4.81541 0.837847 4.5876L4.33785 1.0876C4.56565 0.859797 4.935 0.859797 5.1628 1.0876Z"
      />
    </svg>
  );
}
